"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateNode = void 0;
const state_node_type_1 = require("./interfaces/state-node-type");
const state_event_1 = require("./state-event");
const state_machine_1 = require("./state-machine");
class StateNode {
    constructor(parent, config) {
        var _a, _b, _c;
        this.path = '';
        this.states = [];
        if (parent instanceof state_machine_1.StateMachine) {
            this.machine = parent;
        }
        else {
            this.parent = parent;
            this.machine = parent.machine;
        }
        const { states } = config, stateNodeProps = __rest(config, ["states"]);
        Object.assign(this, stateNodeProps);
        if (!config.name) {
            throw new Error(`Invalid child state name at path: ${this.path}/.`);
        }
        if ((_a = config.name) === null || _a === void 0 ? void 0 : _a.includes('/')) {
            config.name.replace('/', ' ');
            console.error(`Invalid state name: ${config.name}. StateNode's cannot have a name with a forward slash characte ('/')`);
        }
        this.name = config.name;
        this.path = `${((_b = this.parent) === null || _b === void 0 ? void 0 : _b.path) || ''}/${this.name}`;
        this.machine.pathMap.set(this.path, this);
        if (states && states.length > 0) {
            for (const stateConfig of states) {
                this.states.push(new StateNode(this, stateConfig));
            }
        }
        this.events = (_c = config === null || config === void 0 ? void 0 : config.events) === null || _c === void 0 ? void 0 : _c.map(event => event instanceof state_event_1.StateEvent ? event : new state_event_1.StateEvent(this, event));
        this.refreshType();
    }
    findEvent(name, recursive = false) {
        const events = this.events || [];
        for (const event of events) {
            if (event.name === name) {
                return this;
            }
        }
        if (recursive) {
            for (const childStateNode of this.states) {
                const stateNode = childStateNode.findEvent(name, recursive);
                if (stateNode) {
                    return stateNode;
                }
            }
        }
    }
    refreshType() {
        if (!this.type) {
            this.type = state_node_type_1.StateNodeType.Auto;
        }
        if ([state_node_type_1.StateNodeType.Atomic, state_node_type_1.StateNodeType.Auto].includes(this.type) &&
            this.states.length > 0) {
            this.type = state_node_type_1.StateNodeType.Compound;
        }
        else if ([state_node_type_1.StateNodeType.Compound, state_node_type_1.StateNodeType.Auto].includes(this.type) &&
            this.states.length === 0) {
            this.type = state_node_type_1.StateNodeType.Atomic;
        }
    }
    // private getUniqueSiblingName(
    //   name: string,
    //   originalName = name,
    //   count = 2
    // ): string {
    //   if (this.parent) {
    //     for (const sibling of this.parent.states) {
    //       if (sibling !== this && sibling.name === name) {
    //         return this.getUniqueSiblingName(
    //           `${originalName} (${count})`,
    //           originalName,
    //           count + 1
    //         );
    //       }
    //     }
    //   }
    //   return name;
    // }
    getDepth() {
        if (this.parent) {
            return this.parent.getDepth() + 1;
        }
        else {
            return 0;
        }
    }
    getPathTree() {
        if (this.parent) {
            return [...this.parent.getPathTree(), this.path];
        }
        else {
            return [this.path];
        }
    }
    getJsonPath() {
        let path = this.parent ? this.parent.getJsonPath() : '';
        if (this.parent instanceof StateNode) {
            const index = this.parent.states.indexOf(this);
            if (index === -1) {
                throw new Error('Invalid state node. Cannot resolve state node in parent states.');
            }
            path += (path.length > 0 ? '.' : '') + `states[${index}]`;
        }
        return path;
    }
    toJson() {
        var _a, _b;
        return {
            name: this.name,
            type: this.type,
            isInitial: this.isInitial,
            events: (_a = this.events) === null || _a === void 0 ? void 0 : _a.map(event => event.toJson()),
            invoke: this.invoke,
            meta: this.meta,
            onEntry: this.onEntry,
            onExit: this.onExit,
            states: (_b = this.states) === null || _b === void 0 ? void 0 : _b.map(stateNode => stateNode.toJson())
        };
    }
}
exports.StateNode = StateNode;
//# sourceMappingURL=state-node.js.map